import types from './types';

const initialState = {
  fetchingCenters: false,
  centers: [],
  creatingCenter: false,
  updatingCenterById: {},
  deletingCenterById: {}
};

const keyBy = (array, key) =>
  (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});

export const adminCentersReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CENTERS_REQUEST: {
      return {
        ...state,
        fetchingCenters: true
      };
    }
    case types.GET_CENTERS_SUCCESS: {
      return {
        ...state,
        fetchingCenters: false,
        centers: action.centers
      };
    }
    case types.GET_CENTERS_FAILURE: {
      return {
        ...state,
        fetchingCenters: false
      };
    }
    case types.CREATE_CENTER_REQUEST: {
      return {
        ...state,
        creatingCenter: true
      };
    }
    case types.CREATE_CENTER_SUCCESS: {
      return {
        ...state,
        creatingCenter: false
      };
    }
    case types.CREATE_CENTER_FAILURE: {
      return {
        ...state,
        creatingCenter: false
      };
    }
    case types.UPDATE_CENTER_REQUEST: {
      return {
        ...state,
        updatingCenterById: {
          ...state.updatingCenterById,
          [action.id]: true
        }
      };
    }
    case types.UPDATE_CENTER_SUCCESS: {
      return {
        ...state,
        updatingCenterById: {
          ...state.updatingCenterById,
          [action.id]: false
        }
      };
    }
    case types.UPDATE_CENTER_FAILURE: {
      return {
        ...state,
        updatingCenterById: {
          ...state.updatingCenterById,
          [action.id]: false
        }
      };
    }
    case types.DELETE_CENTER_REQUEST: {
      return {
        ...state,
        deletingCenterById: {
          ...state.deletingCenterById,
          [action.id]: true
        }
      };
    }
    case types.DELETE_CENTER_SUCCESS: {
      return {
        ...state,
        deletingCenterById: {
          ...state.deletingCenterById,
          [action.id]: false
        }
      };
    }
    case types.DELETE_CENTER_FAILURE: {
      return {
        ...state,
        deletingCenterById: {
          ...state.deletingCenterById,
          [action.id]: false
        }
      };
    }
    case types.SUBSCRIPTION_CENTER_CREATED: {
      const {
        createdCenter: {
          value: {
            data: { onCreateCenter }
          }
        }
      } = action;
      return {
        ...state,
        centers: [
          ...state.centers,
          onCreateCenter
        ]
      };
    }
    case types.SUBSCRIPTION_CENTER_UPDATED: {
      const {
        updatedCenter: {
          value: {
            data: { onUpdateCenter }
          }
        }
      } = action;
      const centersById = keyBy(state.centers, 'id');
      centersById[onUpdateCenter.id] = onUpdateCenter;
      return {
        ...state,
        centers: Object.values(centersById)
      };
    }
    case types.SUBSCRIPTION_CENTER_DELETED: {
      const {
        deletedCenter: {
          value: {
            data: { onDeleteCenter }
          }
        }
      } = action;
      const centersById = keyBy(state.centers, 'id');
      delete centersById[onDeleteCenter.id];
      return {
        ...state,
        centers: Object.values(centersById)
      };
    }
    default:
      return state;
  }
};
